(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.LnaRoomCatalog = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var SOURCE = 'createur-chambre';

  function allowed(g, gender) {
    return g === 'mixte' || g === gender;
  }

  function visibleProducts(products, gender) {
    var out = [];
    products.forEach(function (p) {
      if (!allowed(p.gender, gender)) return;
      var variants = p.variants.filter(function (v) { return allowed(v.gender, gender); });
      if (variants.length) out.push(Object.assign({}, p, { variants: variants }));
    });
    return out;
  }

  function indexVariants(products) {
    var index = {};
    products.forEach(function (p) {
      p.variants.forEach(function (v) { index[v.id] = { product: p, variant: v }; });
    });
    return index;
  }

  function isVisible(entry, gender) {
    return !!entry && allowed(entry.product.gender, gender) && allowed(entry.variant.gender, gender);
  }

  function hiddenItems(items, gender, index) {
    return items.filter(function (it) { return !isVisible(index[it.variantId], gender); });
  }

  function sanitize(items, index) {
    if (!Array.isArray(items)) return [];
    return items.filter(function (it) {
      var e = it && typeof it === 'object' && index[it.variantId];
      return !!e && e.variant.available;
    });
  }

  function cartLines(items) {
    var lines = [], byId = {};
    items.forEach(function (it) {
      if (byId[it.variantId]) { byId[it.variantId].quantity += 1; return; }
      byId[it.variantId] = { id: it.variantId, quantity: 1, properties: { _source: SOURCE } };
      lines.push(byId[it.variantId]);
    });
    return lines;
  }

  function total(items, index) {
    return items.reduce(function (sum, it) {
      var e = index[it.variantId];
      return sum + (e ? e.variant.price : 0);
    }, 0);
  }

  // Le préfixe générique (« Lampe murale Veilleuse ») ne dit rien sur la carte et mange la place : on le retire, dans chaque langue.
  var GENERIC = [
    /^lampe murale\s+(veilleuse\s+)?(-\s*)?/i, /^wandlampe nachtlicht\s+/i, /^lámpara de pared luz nocturna\s+/i,
    /^lampada da parete luce notturna\s+/i, /^wandnachtlampje\s+/i, /^candeeiro de parede luz de presença\s+/i,
    /\s+wall night light$/i
  ];
  function shortName(title) {
    var t = String(title).trim();
    GENERIC.forEach(function (re) { t = t.replace(re, ''); });
    return t || String(title);
  }

  // L'adresse du produit (…-lettre-a) ne change pas selon la langue, contrairement au nom.
  function letterOf(p) {
    var m = /-([a-z])$/i.exec(p.handle || '');
    return (m ? m[1] : String(p.title).trim().slice(-1)).toUpperCase();
  }

  return { shortName: shortName, letterOf: letterOf, visibleProducts: visibleProducts, indexVariants: indexVariants, isVisible: isVisible,
    hiddenItems: hiddenItems, sanitize: sanitize, cartLines: cartLines, total: total };
});
